<!--
 * @Description  : 上传图片 及 预览组件
 * @Author       : 王帅
 * @Date         : 2020-11-26
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-27 11:55:37
 * @FilePath     : \ngs_platform_manage_admin\src\components\upload\newUpload.vue
-->
<template>
	<div class="file-swiper-container" :class="{ 'border-box': filesList.length > 0 }">
		<template v-if="filesList.length > 0">
			<swiper ref="mySwiper" :options="swiperOptions" class="h100 w100">
				<swiper-slide class="swiper-slide" v-for="(item, index) in filesList" :key="`file_${index}`">
					<img class="slide-image" :src="item.filePath ? `${uploadUrl}${item.filePath}` : getUrl(item.raw)" />

					<!-- 功能按钮区域 -->
					<div class="btn-tools">
						<span class="el-upload-list__item-actions">
							<em class="mr5 el-icon-zoom-in cursor-pointer" title="查看" @click="doView(item)"></em>
							<em class="mr5 el-icon-download cursor-pointer" title="下载" v-if="!isDisabled && item.id" @click="doDownload(item)"></em>
							<em class="el-icon-delete cursor-pointer" title="删除" v-if="mode !== 'view' && !isDisabled" @click="doDelete(item)"></em>
						</span>
					</div>
				</swiper-slide>

				<!-- 分页器 -->
				<div class="swiper-pagination" slot="pagination" v-show="filesList.length > 1"></div>
			</swiper>
		</template>

		<!-- 无图片时显示上传 -->
		<template v-else>
			<el-upload
				class="upload-demo"
				ref="upload"
				action=""
				list-type="picture-card"
				:limit="maxNum"
				:on-exceed="onExceed"
				:on-change="onChange"
				:file-list="filesList"
				:disabled="isDisabled"
				:multiple="multiple"
				:auto-upload="false"
			>
				<el-button v-if="mode != 'view' && !isDisabled" slot="trigger" icon="el-icon-upload" class="upload-text" type="text">{{
					uploadText
				}}</el-button>
				<el-button type="text" v-else class="upload-text" disabled>暂无图片</el-button>
				<!-- 图片模式 -->
				<div slot="file" slot-scope="{ file }" class="picture-box">
					<img class="el-upload-list__item-thumbnail" :src="file.filePath ? `${uploadUrl}${file.filePath}` : file.url" alt="" />
				</div>

				<!-- <div slot="tip" class="el-upload__tip file-tip">
					<p class="text-overflow">当前支持文件格式为: {{ acceptMsg }}</p>
				</div> -->
				<!-- 没有文件时的文字说明 -->
				<!-- <div v-if="fileLength === 0">暂无附件</div> -->
			</el-upload>
		</template>

		<!-- 图片预览 -->
		<el-dialog :visible.sync="dialogObj.visible" title="图片预览" append-to-body center>
			<img width="100%" :src="dialogObj.imgUrl" alt="" />
		</el-dialog>
	</div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { uploadToWeb, saveFile, getFiles_audit, deleteFile, getFiles_userCenter } from 'api/modules/upload'
import { dateFormat } from 'utils/tools'

export default {
	components: {
		Swiper,
		SwiperSlide
	},
	directives: {
		swiper: directive
	},
	props: {
		// 最大文件上传个数
		maxNum: {
			type: Number,
			default: 10
		},
		// 是否支持多选
		multiple: {
			type: Boolean,
			default: true
		},
		// 接收的文件类型
		acceptType: {
			type: Array,
			default: () => {
				return []
			}
		},
		// 回显业务表id
		aid: {
			type: String,
			default: ''
		},
		// 业务表名称
		tableName: {
			type: String,
			default: 'bus_pro_contract'
		},
		// assortment
		assortment: {
			type: String,
			default: ''
		},
		// 文件大小
		fileSize: {
			type: Number,
			default: 10 // 10M
		},
		// 是否可编辑
		isDisabled: {
			type: Boolean,
			default: false
		},
		// 当前查看模式
		mode: {
			type: String,
			default: 'add'
		},
		// 附近是否需要重新加载
		needRefresh: {
			type: Boolean,
			default: false
		},
		// 营业执照需要马上上传获取信息
		uploading: {
			type: Boolean,
			default: false
		},
		// 上传到那个数据库
		forDatabase: {
			type: String,
			default: ''
		},

		// 上传文字
		uploadText: {
			type: String,
			default: '上传图片'
		},
		// 是否需要延迟加载
		lazyTime: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			// filesList: [1, 2, 3, 4, 5],
			filesList: [],
			addList: [],
			swiperOptions: {
				loop: false,
				allowTouchMove: false, // 禁止滑动
				effect: 'fade', // 切换效果
				fadeEffect: {
					crossFade: true
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				}
				// Some Swiper option/callback...
			},
			// 文件预览对象
			dialogObj: {
				visible: false,
				imgUrl: ''
			}
		}
	},
	created() {
		if (this.aid) {
			setTimeout(() => {
				this.getFiles_audit()
			}, this.lazyTime)
		}
	},
	methods: {
		// 文件超出个数限制时的钩子
		onExceed() {
			this.$message.warning('当前最多可上传' + this.maxNum + '个文件！')
		},

		// 文件列表变化事件 --- 判断格式 大小等
		onChange(file, fileList) {
			// console.log(file)
			// console.log(fileList)
			if (file.size / 1024 / 1024 > this.fileSize) {
				this.$message.warning(`温馨提示：上传图片大小不能超过${this.fileSize}兆`)
				fileList.forEach((x, index) => {
					if (x.uid == file.uid) {
						fileList.splice(index, 1)
					}
				})
			} else {
				let curType = file.name.substring(file.name.lastIndexOf('.') + 1)
				if (this.checkType(curType)) {
					// 如果不存在id 是添加情况
					if (!file.id) {
						this.filesList.push(file)
						// this.$refs.upload.clearFiles()
						this.uploading ? this.fileToWeb() : ''
					}
				} else {
					this.doDelete(file)
				}
			}
		},

		// 检测所选文件是否符合格式
		checkType(curType) {
			if (this.acceptType.length > 0) {
				if (this.acceptType.find((x) => x === curType)) {
					return true
				} else {
					this.$message.warning('文件格式不对，请重新选择!')
					return false
				}
			} else {
				return true
			}
		},

		// 获取图片地址
		getUrl(file) {
			var url = null
			if (window.createObjectURL != undefined) {
				url = window.createObjectURL(file)
			} else if (window.URL != undefined) {
				url = window.URL.createObjectURL(file)
			} else if (window.webkitURL != undefined) {
				url = window.webkitURL.createObjectURL(file)
			}
			return url
		},

		// 数据回显
		getFiles_audit() {
			if (this.forDatabase == 'user_tenent_center') {
				getFiles_userCenter({
					aid: this.aid,
					tableName: this.tableName,
					assortment: this.assortment
				})
					.then((res) => {
						this.filesList = res.data
					})
					.catch((err) => {
						this.filesList = []
					})
			}
		},

		// 查看文件
		doView(file) {
			this.dialogObj.imgUrl = file.filePath ? this.$uploadUrl + file.filePath : this.getUrl(file.raw)
			this.dialogObj.visible = true
		},

		// 下载文件
		doDownload(file) {
			// fileDownload(file.id)
			// this.$message.info('')
			if (file.id) {
				window.open(this.uploadUrl + file.filePath)
			}
		},

		// 删除文件
		doDelete(file) {
			let _index = this.filesList.findIndex((x) => x.uid === file.uid)
			// 如果有ID 弹窗提示
			if (file.id) {
				this.$confirm('确认要删除当前附件吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						deleteFile({ id: file.id })
							.then((res) => {
								// console.log(res)
								this.$message.success('删除成功!')
								this.filesList.splice(_index, 1)
							})
							.catch((err) => {})
					})
					.catch(() => {})
			} else {
				// 否则直接删除
				this.filesList.splice(_index, 1)
				// this.$refs.upload.uploadFiles.splice(_index, 1)
			}
		},

		// 上传到 服务器
		fileToWeb(aid, item) {
			let that = this
			let status = false
			if (this.filesList.length > 0) {
				for (let item of this.filesList) {
					if (item.id) {
						status = true
						continue
					}
					let formData = new FormData()
					formData.append('file', item.raw)
					formData.append('path', dateFormat('yyyy-mm-dd'))
					formData.append('output', 'json')

					let nameArr = item.name.split('.')
					let suffix = nameArr[nameArr.length - 1]
					let _name = `${this.$SnowFlake.nextId()}_${this.$generateRandomString()}.${suffix}`
					formData.append('filename', _name)

					uploadToWeb(formData)
						.then((res) => {
							// console.log(res)
							that.uploading ? '' : that.fileUpload(aid, res)
							that.$emit('getDataParams', res)
							// this.uploadMessage(true)
						})
						.catch((err) => {
							that.$message.error('附件上传服务器失败！')
							// that.doRefresh()
							return false
						})
				}

				if (status) {
					this.$emit('on-success')
				}

				// this.$refs.upload.submit()
			} else {
				// this.doRefresh()
				this.$emit('on-success')
			}
		},

		// 文件上传方法 --- 上传数据库
		fileUpload(uploadId, params) {
			// 在有上传数据的情况下
			let _aid = uploadId

			let dataParams = {
				path: params.path,
				md5: params.md5,
				size: params.size,
				aid: _aid,
				tableName: this.tableName,
				assortment: this.assortment
			}
			setTimeout(() => {
				saveFile(dataParams)
					.then((res) => {
						// this.$message.success('附件上传成功！')
						// this.doRefresh()
						this.$emit('on-success')
					})
					.catch((err) => {
						// this.$message.error('附件上传数据库失败！')
						// this.doRefresh()
						this.$emit('on-success')
					})
			}, this.lazyTime)
		}
	},
	computed: {
		// 当前文件列表数量
		fileLength() {
			return this.$refs.upload.uploadFiles.length
		},

		// 支持的文件格式 文字
		acceptMsg() {
			return this.acceptType.length > 0 ? JSON.stringify(this.acceptType) : '所有格式文件'
		},

		// 上传接口地址
		uploadUrl() {
			return this.$uploadUrl
		}
	},
	watch: {
		aid(val) {
			if (val) {
				setTimeout(() => {
					this.getFiles_audit()
				}, this.lazyTime)
			}
		},
		needRefresh(val) {
			if (val && this.aid) {
				setTimeout(() => {
					this.getFiles_audit()
				}, this.lazyTime)
			}
		}
	}
}
</script>

<style scoped lang="less">
.file-swiper-container {
	min-width: 200px;
	min-height: 120px;
	width: 100%;
	height: 100%;
	position: relative;
	// border: 1px solid #ccc;

	.swiper-pagination {
		text-align: right;
		padding: 0 8px;
		bottom: 5px;
	}

	.slide-image {
		width: 100%;
		height: 100%;
	}

	.btn-tools {
		position: absolute;
		right: 0;
		top: 0;
		background-color: #2d2d2d6e;
		height: 30px;
		line-height: 30px;
		padding: 0 8px;
		color: #fff;
	}
}

.border-box {
	border: 1px solid #ccc;
}

.upload-demo {
	height: 100%;
	color: #666;
	font-size: 14px;

	/deep/ .file-tip {
		font-size: 12px;
		margin-top: 0;
		height: 30px;
		line-height: 30px;
	}
	/deep/ .el-upload {
		width: 100%;
		height: 100%;
	}

	.upload-text {
		vertical-align: text-bottom;
		display: inline-block;

		/deep/ span {
			margin-top: -11px;
			display: inline-block;
			vertical-align: middle;
		}
	}
}
</style>
